<template>
<div>
  <v-row no-gutters>
    <v-col :cols="colsMain">

      <v-row class="mgmt-panel">
        <Breadcrumbs :breadcrumbs="breadcrumbs" />

        <v-spacer></v-spacer>
        <MgmtButtons
          :view="view"
          :acl="acl"
          :system="item.system"
          @createItem="createItem"
          @deleteItem="deleteItem"
          @toView="toView"
          @toEdit="toEdit"
        />

      </v-row>
        <hr />

      <StaticTabs :selected="activeTab" light class="elevation-0">
        <v-tab href="#info" @click="activeTab = 'info'">Инфо</v-tab>
        <!-- <v-tab v-if="!isNew" href="#system" @click="activeTab = 'system'">Системные</v-tab> -->

        <v-tab-item value="info" class="tab-item" :style="{ 'max-height': `${tabHeight}px` }">
          <v-row no-gutters class="tab-row">
             <v-col :cols="cols13">
              <v-card light class="info-block" :class="{ 'no-right-margin': device === 'mobile' }">
                <!-- <v-card-title class="primary--text">Сводка</v-card-title> -->
                <v-card-text>

                  <table class="view-table" width="100%" >
                    <tr>
                      <th>Сотрудник:</th>
                      <td>
                        <router-link v-if="item.unit" :to="{ name: 'unit_view', params: { id: item.unit.id }}">
                         {{ item.unit.name }}
                        </router-link>
                      </td>
                    </tr>
                  </table>

                  <table class="view-table mt-6" width="100%" >
                    <caption style="text-align: left;">
                      <router-link v-if="item.subaccount && item.subaccount.id" :to="{ name: 'unit_account_view', params: { id: item.subaccount.id, tab: 'credit' }}">Кредитовый субсчет:</router-link>
                    </caption>

                    <tr>
                      <th>Текущая задолженность:</th>
                      <td>
                        {{ item.full_debt|moneyFormatFilter }} р.
                      </td>
                    </tr>

                    <tr>
                      <th>Переход. задолженность:</th>
                      <td>{{ item.passing_debt|moneyFormatFilter }} р.</td>
                    </tr>

                    <tr>
                      <th>Вычет (сумма погашения):</th>
                      <td>{{ item.extra_data && item.extra_data.extra_view_total_refund|moneyFormatFilter }} р.</td>
                    </tr>
                  </table>



                  <table class="view-table mt-6" width="100%" >
                    <caption style="text-align: left;">
                      <router-link v-if="item.subaccount && item.subaccount.id" :to="{ name: 'unit_account_view', params: { id: item.subaccount.id, tab: 'debt' }}">Дебетовый субсчет (депонент, оставить сумму на хранение в организации):</router-link>
                      </caption>

                    <tr>
                      <th>Сейчас на депозите:</th>
                      <td>
                        {{ item.full_deponent|moneyFormatFilter }} р.
                      </td>
                    </tr>

                    <tr>
                      <th>Выдать с депозита:</th>
                      <td>
                        {{ item.from_deponent|moneyFormatFilter }} р.
                      </td>
                    </tr>

                    <tr>
                      <th>Оставить сумму:</th>
                      <td>
                        {{ item.deponent|moneyFormatFilter }} р.
                      </td>
                    </tr>
                  </table>


                  <table class="view-table mt-6" width="100%" >
                    <caption style="text-align: left;">Сводка:</caption>

                    <tr>
                      <th>Отработано смен:</th>
                      <td>
                        <b>{{ item.days_all }}</b>
                        <span v-if="item.days_updated !== 0" :class="item.days_updated >= 0 ? 'green--text' : 'red--text'"> ({{ item.days_updated }})</span>
                      </td>
                    </tr>

                    <tr>
                      <th>Отработано часов:</th>
                      <td>
                        <b>{{ item.hours_all }}</b>
                        <span v-if="item.hours_updated !== 0" :class="item.hours_updated >= 0 ? 'green--text' : 'red--text'"> ({{ item.hours_updated }})</span>
                      </td>
                    </tr>

                    <tr>
                      <th>Средняя ставка:</th>
                      <td>{{ item.average_rate|moneyFormatFilter }} р.</td>
                    </tr>

                    <tr>
                      <th>Начислено:</th>
                      <td>{{ item.accrued|moneyFormatFilter }} р.</td>
                    </tr>
                  </table>






                  <table class="view-table mt-6" width="100%" >
                    <caption style="text-align: left;">
                      <router-link :to="{ name: 'unit_debt_list' }">Основания долга сотрудника:</router-link>
                    </caption>

                    <tr v-for="i in item.unit_debt_extra_headers" :key="i.id">
                      <th>
                        <div>{{ i.text }}:</div>
                        <div v-if="i.value.startsWith('extra_edit_')" :class="i.class" class="text-caption">(погасить)</div>
                        <div v-else :class="i.class" class="text-caption">(долг)</div></th>

                      <td>
                        <div>{{ item.extra_data[i.value]|moneyFormatFilter }} р.</div>
                      </td>
                    </tr>

                  </table>


                  <table class="view-table mt-6" width="100%" >
                    <caption style="text-align: left;">Долги:</caption>

                    <tr>
                      <th>Сумма долга:</th>
                      <td>
                        {{ item.extra_data && item.extra_data.extra_view_total_debt|moneyFormatFilter }} р.
                      </td>
                    </tr>

                    <tr>
                      <th>Сумма погашения:</th>
                      <td>{{ item.extra_data && item.extra_data.extra_view_total_refund|moneyFormatFilter }} р.</td>
                    </tr>

                    <tr>
                      <th>Остаток долга:</th>
                      <td>{{ item.extra_data &&  item.extra_data.extra_view_debt_residue|moneyFormatFilter }} р.</td>
                    </tr>
                  </table>



                  <table class="view-table mt-6" width="100%" >
                    <caption style="text-align: left;">
                      <router-link :to="{ name: 'unit_refund_list' }">Основание для компенсации сотрудника:</router-link>
                    </caption>

                    <tr v-for="i in item.unit_refund_extra_headers" :key="i.id">
                      <th>
                        <div>{{ i.text }}:</div>
                        <div :class="i.class" class="text-caption">(начислить)</div>
                      </th>

                      <td>
                        <div>{{ item.extra_data[i.value]|moneyFormatFilter }} р.</div>
                      </td>
                    </tr>

                  </table>


                  <table class="view-table mt-6" width="100%" >
                    <caption style="text-align: left;">Компенсации:</caption>

                    <tr>
                      <th>Сумма компенсаций:</th>
                      <td>
                        {{ item.extra_data && item.extra_data.extra_view_total_compensation|moneyFormatFilter }} р.
                      </td>
                    </tr>
                  </table>




<!--                   <table class="view-table mt-6" width="100%" >
                    <caption style="text-align: left;">Кредитовый субсчет:</caption>

                    <tr>
                      <th>Текущая задолженность:</th>
                      <td>
                        <router-link v-if="item.subaccount && item.subaccount.id" :to="{ name: 'unit_account_view', params: { id: item.subaccount.id, tab: 'credit' }}">{{ item.full_debt|moneyFormatFilter }} р.</router-link>
                      </td>
                    </tr>

                    <tr>
                      <th>Переход. задолженность:</th>
                      <td>{{ item.passing_debt|moneyFormatFilter }} р.</td>
                    </tr>

                    <tr>
                      <th>Вычет (сумма погашения):</th>
                      <td>
                        <validation-provider rules="decimal" vid="debt" v-slot="{ errors }" name="'Вычет (сумма погашения)'">
                        <v-text-field
                          outlined
                          hide-details
                          :disabled="item.status ==='close'"
                          dense
                          type="number"
                          name="debt"
                          v-model="item.debt"
                          class="mb-1 mt-1 text_fields__backgroung"
                          :error-messages="errors[0]"
                        />
                        </validation-provider>
                      </td>
                    </tr>
                  </table> -->

<!--                   <div>
                    <validation-provider rules="" vid="debt_comment" v-slot="{ errors }" name="'Комментарий к погашению задолж.'">
                    <v-textarea
                      name="debt_comment"
                      rows="2"
                      row-height="25"
                      :disabled="item.status ==='close'"
                      v-model="item.debt_comment"
                      label="Комментарий к погашению задолжен."
                      :error-messages="errors[0]"
                    ></v-textarea>
                    </validation-provider>
                  </div> -->



                  <table class="view-table mt-6" width="100%" >
                    <caption style="text-align: left;">Доп. выплаты и снятия:</caption>

<!--                     <tr>
                      <th>Премия:</th>
                      <td>
                        <validation-provider rules="decimal" vid="award" v-slot="{ errors }" name="'Премия'">
                          <v-text-field
                            outlined
                            hide-details
                            dense
                            type="number"
                            name="award"
                            :disabled="item.status ==='close'"
                            v-model="item.award"
                            class="mb-1 mt-1 text_fields__backgroung"
                            :error-messages="errors[0]"
                          />
                        </validation-provider>
                      </td>
                    </tr>

                    <tr>
                      <th>Компенсация:</th>
                      <td>
                        <validation-provider rules="decimal" vid="amends" v-slot="{ errors }" name="'Компенсация'">
                        <v-text-field
                          outlined
                          hide-details
                          dense
                          :disabled="item.status ==='close'"
                          type="number"
                          name="amends"
                          v-model="item.amends"
                          class="mb-1 mt-1 text_fields__backgroung"
                          :error-messages="errors[0]"
                        />
                        </validation-provider>
                      </td>
                    </tr>

                    <tr>
                      <th>Лишение премии:</th>
                      <td>
                        <validation-provider rules="decimal" vid="fine" v-slot="{ errors }" name="'Лишение премии'">
                        <v-text-field
                          outlined
                          hide-details
                          :disabled="item.status ==='close'"
                          dense
                          type="number"
                          name="fine"
                          v-model="item.fine"
                          class="mb-1 mt-1 text_fields__backgroung"
                          :error-messages="errors[0]"
                        />
                        </validation-provider>
                      </td>
                    </tr> -->

                    <tr>
                      <th>НДФЛ:</th>
                      <td>{{ item.ndfl|moneyFormatFilter }} р.</td>
                    </tr>

                    <tr>
                      <th>На карту:</th>
                      <td>
                        {{ item.to_card|moneyFormatFilter }} р.
                      </td>
                    </tr>
                  </table>


                  <table class="view-table mt-6" width="100%" >
                    <caption style="text-align: left;">Итого:</caption>
                    <tr>
                      <th>К выплате:</th>
                      <td><b>{{ item.amount|moneyFormatFilter }} р.</b></td>
                    </tr>

                  </table>

                  <div>
                    {{ item.comment }}
                  </div>

                </v-card-text>
              </v-card>
            </v-col>

            <v-col :cols="cols23">
              <PayrollShifts
                :id="id"
                :item="item"
                :view2="view"
                :key="id"
                @load="load"
              />
             </v-col>


          </v-row>
        </v-tab-item>

<!--         <v-tab-item class="tab-item" :style="{ 'max-height': `${tabHeight}px` }" value="system">
          <v-row no-gutters class="tab-row">
            <v-col :cols="cols125">
              <v-card light class="info-block" :class="{ 'no-right-margin': device === 'mobile' }">
                <v-card-text>
                  <table class="view-table">
                    <tr>
                      <th>Создан:</th>
                      <td>{{ item.created_by_name }}</td>
                    </tr>
                    <tr>
                      <th>Дата создания:</th>
                      <td>{{ item.date_created }}</td>
                    </tr>
                    <tr>
                      <th>Изменен:</th>
                      <td>{{ item.modified_by_name || '---' }}</td>
                    </tr>
                    <tr>
                      <th>Дата изменения:</th>
                      <td>{{ item.date_modified || '---' }}</td>
                    </tr>
                  </table>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-tab-item> -->

      </StaticTabs>

    </v-col>

    <v-col :cols="colsBar">
      <v-row no-gutters>
        <v-spacer></v-spacer>
        <RefFilter
          class="user-filter"
          :query="initialQuery"
          :count="count"
          :filterPending="filterPending"
          :countTotal="countTotal"
          @filteredLoad="filteredLoadCollbar"
        />

      </v-row>
      <hr />
      <CollectionBar
        :id="item.id"
        :items="coll"
        :count="count"
        :loading="loadingCollbar"
        :scrollBusy="scrollBusy"
        @loadCollbar="loadCollbar"
        @toEdit="toEdit"
        @toView="toView"
      />
    </v-col>

  </v-row>
<!--   <Confirmation
    :opened="confirmation.opened"
    :title="confirmation.title"
    :text="confirmation.text"
    :pendingSave="confirmation.pendingSave"
    @confirm="confirmConfirmationAction"
    @cancel="cancelConfirmationAction"
  /> -->
</div>
</template>

<script>
import { get, edit } from '@/api'
import RefFilter from '@/components/filters/RefFilter'
import PayrollShifts from '@/components/accounting/PayrollShifts'
import ViewMixin from '@/views/View.vue'

export default {
  mixins: [ViewMixin],
  components: {
    RefFilter,
    PayrollShifts
  },
  computed: {
  },
  data: function () {
    return {
      modelName: 'Payroll',
      viewName: 'payroll',
      viewTitle: 'Ведомость',
      parentHref: `#/managment/accounting/payroll_list/view/${this.$route.params.lst_id}?tab=payroll`,

      urlObj: 'accounting/payroll/',

      // item
      item: {
        id: this.id,
        name: ''
      },

      // collbar
      options: {
        sortBy: ['unit__last_name'],
        sortDesc: [false],
        itemsPerPage: 25,
        page: 1
      },
      collbar: {
        url: `accounting/payroll_list/${this.$route.params.lst_id}/payrolls/`,
        name: 'payroll_list'
      },
    }
  },
  methods: {
    setBreadcrumb () {
      this.breadcrumbs = [{
        text: 'Список ведомостей',
        disabled: false,
        href: '#/managment/accounting/payroll_list',
      }, {
        text: this.viewTitle,
        disabled: false,
        href: this.parentHref,
      }]

      if (this.item.id) {
        this.breadcrumbs.push({ text: this.item.name, disabled: true })
      }
    },
    edit () {
      this.pendingSave = true
      this.$store.commit('SET_LOADING', true)
      edit(this.urlObj, this.item.id, this.item).then((response) => {
        this.item = response.data
        this.pendingSave = false
        this.$store.commit('SET_LOADING', false)
        this.$notify({ group: 'main', title: 'Сохранить', text: 'Успешно!', type: 'success' })
      }).catch((err) => {
        console.log('ERRR', err.response)
        this.pendingSave = false
        const firstKey = Object.keys(err.response.data)[0]
        const error = err.response.data[firstKey]
        this.$notify({ group: 'main', title: 'Сохранить', text: 'Ошибка! ' + ' ' + error, type: 'error' })
        this.$refs.form.setErrors(err.response.data)
        this.$store.commit('SET_LOADING', false)
      })
    },
  },
}
</script>
<style>
.text_fields__backgroung {
  background-color: white;
}
</style>
